export const ShoulderZOffset: number = 0.25;
export const ShoulderXOffset: number = 0.225;
export const ShoulderHeight: number = 1.425;
export const ArmHalfLength: number = 0.3;
export const BasePatternHeight: number = 1.05;
export const ArmAngle: number = 0.2;
